import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import BookingDemo from "./demo/BookingDemo";
import MenuDemo from "./demo/MenuDemo";

export default function DemoPreview() {
  return (
    <section id="demo" className="relative overflow-hidden border-y border-line bg-panel py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            tag="Provalo adesso"
            title={
              <>
                Non fidarti delle parole: <em className="italic text-terracotta">prenota un tavolo.</em>
              </>
            }
            sub="Il sistema di prenotazione e il menù QR che installiamo nei siti dei nostri clienti, funzionanti qui con i piatti reali di un ristorante di Mestre. Nessun dato viene salvato."
          />
          <Reveal delay={0.2}>
            <Link
              to="/demo"
              data-testid="demo-preview-open-link"
              className="group inline-flex items-center gap-2 rounded-full border border-line-strong px-6 py-3.5 font-accent text-xs uppercase tracking-[0.18em] text-bone transition-colors duration-300 hover:border-terracotta hover:text-terracotta"
            >
              Apri la demo completa
              <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-14 grid items-start gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <BookingDemo />
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5">
            <MenuDemo compact />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
